import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchDataSummary } from "./summaryAPI";

const initialState = {};
const reducers = {};

export const dataSummaryThunk = createAsyncThunk('dataSummary/load', async ()=>{
    const payload = await fetchDataSummary();
    return payload;
});

const dataSummarySlice = createSlice({
    name: 'dataSummary',
    initialState,
    reducers,
    extraReducers: (builder)=>{
        builder
            .addCase(dataSummaryThunk.fulfilled, (state, action)=> ({ ...action.payload }))
    }
});

export default dataSummarySlice.reducer;
